/* eslint-disable no-invalid-this */
import { watchTime } from "@/api/apiWS";

export default function() {
  const store = this.$store
  const userInfo = store.getters['userInfo']
  const channelInfo = store.getters['channelInfo']
  const websocketHeartbeat = require('./timer').default;
  const info = {
      "userId": userInfo.id || 0,
      //  "token": this.token,
      "id": channelInfo.id,
      "type":"radio",
      "uin": channelInfo.uin,
      "liveNowStatus": channelInfo.liveStatus
  }
  return websocketHeartbeat({
    url: watchTime,
    pingTimeout: 5000,
    pongTimeout: 5000,
    manualStart: false,
    repeatLimit: 10,
    userInfo: info,
    webworker: false
  }).useIt('uuid').useIt('ua')
}
